/* import __COLOCATED_TEMPLATE__ from './saved-messages-edit-messages.hbs'; */
import Component from '@ember/component';

/**
 * Shows a list of saved messages with various call-to-actions (edit/delete)
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: '',

  /**
   * @param {function}
   */
  addNewMessage: undefined,

  /**
   * @param {function}
   */
  deleteMessage: undefined,

  /**
   * @param {function}
   */
  cancelEditMessages: undefined,

  /**
   * @param {function}
   */
  editMessage: undefined,

  /**
   * @inheritDoc
   */
  actions: {
    /**
     * Called when the user clicks the create message call-to-action
     */
    addNewMessage() {
      this.addNewMessage();
    },

    /**
     * Called when the user clicks the delete message call-to-action
     *
     * @param {DS.Model} message
     */
    deleteMessage(message) {
      this.deleteMessage(message);
    },

    /**
     * Called when the user clicks on the done call-to-action
     */
    done() {
      this.cancelEditMessages();
    },

    /**
     * Called when the user clicks on the edit call-to-action
     *
     * @param {DS.Model} message
     */
    editMessage(message) {
      this.editMessage(message);
    },
  },
});
